module.exports = __webpack_public_path__ + "img/icon-solid-close.1c829321.svg";